// extracted by mini-css-extract-plugin
module.exports = {"group":"RadioGroup_group__2bzj7"};